import { ColorValue } from "ui";
import { useEffect } from "react";

export function useSetBodyBgColor(colorValue: ColorValue): void {
  useEffect(() => {
    if (window) {
      window.document.body.style.backgroundColor = colorValue;
    }
  }, [colorValue]);
}
